import './scss/index.scss';
import * as bootstrap from 'bootstrap';
import feather from "../assets/js/first-icons.min";
import pageHeaderDisplay from '../assets/js/pageheader/pageheader.display';
import modalControl from '../assets/js/modalcontrol/modalcontrol.secondaryClose';
import modalControlUpdateContent from '../assets/js/modalcontrol/modalcontrol.updateContent';
import timeline from '../assets/js/timeline';
// import serviceUpdateLinksDisplay from '../assets/js/serviceUpdateLinks/serviceUpdateLinks.display';

window.bootstrap = bootstrap;

(($, Drupal) => {
  Drupal.behaviors.accordionScrollTo = {
    attach: function (context, settings) {
      let accordions = document?.querySelectorAll(".accordion-item");
      
      accordions?.forEach(element => {
        element?.addEventListener("click", () => {
          let toggleBtn = element.querySelector('button');
          let isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
          let scrollOffset = window.innerWidth > 768 ? 80 : 140;

          if (isExpanded) {
            const y = element.getBoundingClientRect().top + window.scrollY - scrollOffset;
            window.scrollTo({
              top: Math.max(0, y),
              behavior: "smooth",
            });
          }
        });
      });      
    }
  };
})(jQuery, Drupal);

(($, Drupal) => {
  Drupal.behaviors.timelineComponent = {
    attach: function (context, settings) {
      timeline.dragScroll();
      timeline.navigation();
    }
  };
})(jQuery, Drupal);

(($, Drupal) => {
  Drupal.behaviors.updatedPageHeader = {
    attach: function (context, settings) {
      pageHeaderDisplay.checkPageTitle();
    }
  };
})(jQuery, Drupal);

(($, Drupal) => {
  Drupal.behaviors.modalCloseButton = {
    attach: function (context, settings) {
      modalControl.listenForSecondaryCloseBtnClick();
    }
  };
})(jQuery, Drupal);

(($, Drupal) => {
  Drupal.behaviors.modalUpdateContent = {
    attach: function (context, settings) {
      modalControlUpdateContent.init();
    }
  };
})(jQuery, Drupal); 

// (($, Drupal) => {
//   Drupal.behaviors.serviceUpdateLinks = {
//     attach: function (context, settings) {
//       serviceUpdateLinksDisplay.checkServiceUpdateLinks();
//     }
//   };
// })(jQuery, Drupal);

(($, Drupal) => {
  Drupal.behaviors.sillyStampedAnimation = {
    attach: function (context, settings) {
      if ($('.page-header img[src*="mission-logo.png"]').length > 0) {
        const imgWrapper = $('<div class="logo-stamped-animation position-relative"></div>')
        $('.page-header img').wrap(imgWrapper);

        const imgElem = $('<img class="rubber-stamp position-absolute top-0 h-100 start-50" src="/sites/default/files/public/node_images/accepted-logo.png">');

        $('.page-header .logo-stamped-animation').append(imgElem);

        setTimeout(() => {
          $('.page-header .rubber-stamp').addClass('loaded');
        }, 750);
      }
    }
  };
})(jQuery, Drupal, once);

(function ($, Drupal, once) {
  Drupal.behaviors.firstbusFadeAnimations = {
    attach: function (context, settings) {

      const cards = document.querySelectorAll('[data-fade]');

      const cardObserverCallback = (cardsToWatch, cardObserver) => {
        cardsToWatch.forEach(cardToWatch => {
          if(cardToWatch.isIntersecting) {
            cardToWatch.target.classList.add('faded');
            cardObserver.unobserve(cardToWatch.target);
          }
        })
      }

      const cardObserverOptions = {
        threshold: .5
      }

      const cardObserver = new IntersectionObserver(cardObserverCallback, cardObserverOptions);

      cards.forEach(card => {
        cardObserver.observe(card);
      })
    }
  };
})(jQuery, Drupal, once);

(($, Drupal) => {
  Drupal.behaviors.featherReplace = {
    attach: function (context, settings) {
      feather.replace();
    }
  }
})(jQuery, Drupal);

(($, Drupal) => {
  Drupal.behaviors.ediCarousel = {
    attach: function (context, settings) {
      if ($('#first-bus-edi-timeline').length > 0) {
        var slider;

        slider = tns({
          container: '#first-bus-edi-timeline',
          items: 1,
          nav: true,
          gutter: 15,
          controls: false,
          navPosition: 'top',
          navAsThumbnails: true,
          mode: 'gallery',
          speed: 600
        });
      }
    }
  };
})(jQuery, Drupal, once);

(($, Drupal, once) => {
  Drupal.behaviors.megaMenu = {
    attach: function (context, settings) {
      function sizeMegaMenus() {
        $('.main-navigation .dropdown-menu').each(function() {
          var count = parseInt($(this).attr('data-count'), 10);

          if (count > 12) {
            $(this).css({ width: '900px' });
          } else if (count > 6) {
            $(this).css({ width: '600px' });
          } else {
            $(this).css({ width: '300px' });
          }
        });
      }

      sizeMegaMenus();

      $(window).on('resize', function() {
        if ($(window).width() < 992) {
          $('.main-navigation').addClass('d-lg-flex');
        } else {
          $('.main-navigation').addClass('d-lg-flex');
          $('.mobile-main-menu').addClass('d-lg-none');

          var hw = $('header.fixed-top').width();
          var lw = $('.navbar-brand').width() + 40;
          var mw = $('.main-navigation').width();

          // console.log('header w', hw)
          // console.log('logo w', lw)
          // console.log('menu w', mw)

          if (mw > 0) {
            if ((lw + mw) > hw) {
              $('.main-navigation').removeClass('d-lg-flex');
              $('.mobile-main-menu').removeClass('d-lg-none');
              $('.d-lg-block .menu--regions button').addClass('btn-sm');
            } else {
              $('.main-navigation').addClass('d-lg-flex');
              $('.mobile-main-menu').addClass('d-lg-none');
              $('.d-lg-block .menu--regions button').removeClass('btn-sm');
            }
          }
        }
      }).trigger('resize');

      $('.main-navigation .dropdown')
        .on('shown.bs.dropdown', function() {
          $('.dropdown-toggle', this).removeClass('border-white').addClass('border-primary');
          var dd = $('.dropdown-menu', this);

          if (dd.get(0).getBoundingClientRect().right > $(window).width()) {
            dd.addClass('dropdown-menu-end');
          }

          var max = $('header.fixed-top').get(0).getBoundingClientRect().bottom + 20;
          dd.css({ 'max-height': 'calc(100vh - ' + max + 'px)' });
        })
        .on('hidden.bs.dropdown', function() {
          $('.dropdown-toggle', this).removeClass('border-primary').addClass('border-white');
          $('.dropdown-menu', this).removeClass('dropdown-menu-end');
        });

      $('.menu--regions.dropdown')
        .on('shown.bs.dropdown', function() {
          var dd = $('.dropdown-menu', this);
          var max = $('header.fixed-top').get(0).getBoundingClientRect().bottom + 20;
          dd.css({ 'max-height': 'calc(100vh - ' + max + 'px)' });
        })
        .on('hidden.bs.dropdown', function() {

        });

      function positionHeader() {
        var hh = $('header.fixed-top').get(0).getBoundingClientRect().height;
        var h = 0;

        if ($('#toolbar-administration').length > 0) {
          h = $('#toolbar-administration #toolbar-bar')
            .get(0)
            .getBoundingClientRect()
            .height;
          h += $('#toolbar-administration #toolbar-item-administration-tray')
            .get(0)
            .getBoundingClientRect()
            .height;
          $('header.fixed-top').css({ top: h + 'px' });
        }

        // Ceiling, not floor: rounding down leaves a sliver of content
        // hidden under the header when its height is fractional.
        $('.dialog-off-canvas-main-canvas').css({ 'padding-top': Math.ceil(hh) + 'px' });
      }

      // The static padding in _body.scss covers first paint; from here the
      // header's own size drives the offset, so a service updates banner
      // rendering or being dismissed, and fonts settling, correct the
      // padding within a frame instead of after a timer.
      var headerEl = $('header.fixed-top').get(0);
      if (headerEl && 'ResizeObserver' in window) {
        new ResizeObserver(function () {
          positionHeader();
        }).observe(headerEl);
      }

      // Window resizes can move the admin toolbar without changing the
      // header's own size, so this listener stays alongside the observer.
      $(window).on('resize', function() {
        positionHeader();
      }).trigger('resize');
    }
  }
})(jQuery, Drupal);

(function ($, Drupal, once) {
  Drupal.behaviors.headerDropmenu = {
    attach: function (context, settings) {
      $('header .dropdown, .menu--regions button[data-bs-toggle="dropdown"]')
        .on('show.bs.dropdown', event => {
          if ($(window).width() < 576) {
            $('html').addClass('overflow-y-hidden');
            $('header.fixed-top').prepend('<div class="dropdown-mobile-overlay modal-backdrop fade show"></div>');
          }
        })
        .on('hide.bs.dropdown', event => {
          if ($(window).width() < 576) {
            $('html').removeClass('overflow-y-hidden');
            $('header.fixed-top').find('.dropdown-mobile-overlay').remove();
          }
        })
    }
  };

  Drupal.behaviors.opcoPromoCarousel = {
    attach: function (context, settings) {
      if ($('.opco-promo-carousel').length > 0) {
        var slider;

        slider = tns({
          container: '.opco-promo-carousel',
          items: 1,
          nav: true,
          gutter: 15,
          controls: false,
          navPosition: 'bottom',
          mode: 'gallery',
          speed: 600,
          autoplay: true,
          autoplayButton: false,
          autoplayButtonOutput: false
        });
      }
    }
  };

  Drupal.behaviors.appCarousel = {
    attach: function (context, settings) {
      if ($('.first-bus-app-carousel').length > 0) {
        var slider;

        slider = tns({
          container: '.first-bus-app-carousel',
          items: 1,
          nav: false,
          gutter: 15,
          controls: true,
          responsive: {
            640: {
              items: 2
            },
            720: {
              items: 3
            }
          }
        });
      }
    }
  };

  Drupal.behaviors.homeNewsTinyCarousel = {
    attach: function (context, settings) {
      if ($('.fb-news-home-tiny-carousel').length > 0) {
        let slider;
        let responsive = {};

        const newsItemsCount = $('.fb-news-home-tiny-carousel > div').length;

        switch (newsItemsCount) {
          case 1:
          case 2:
            responsive = {
              640: {
                items: 2
              }
            };
            break;
          case 3:
            responsive = {
              640: {
                items: 2
              },
              720: {
                items: 3
              }
            };
            break;
          default:
            responsive = {
                640: {
                items: 2
              },
                720: {
                items: 3
              },
                840: {
                items: 4
              },
            };
        }

        let sliderPromise = new Promise(function(sliderResolve) {
          slider = tns({
            container: '.fb-news-home-tiny-carousel',
            items: 1,
            nav: false,
            gutter: 15,
            controls: true,
            controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left text-primary"><polyline points="15 18 9 12 15 6"></polyline></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right text-primary"><polyline points="9 18 15 12 9 6"></polyline></svg>'],
            responsive: responsive,
          });

          sliderResolve(slider);
        });

        sliderPromise.then(function(sliderContainer) {
          const feather = require('feather-icons');
          feather.replace();
        });
      }
    }
  };

  $('.spider-share').each(function() {
    var postUrl = $(this).attr('data-share-url');
    var postTitle = encodeURIComponent($(this).attr('data-share-title'));

    $('button', this).on('click', function () {
      dataLayer.push({
        'event': 'social',
        'site': $(this).attr('class'),
        'url': document.location
      });
    });

    $('.facebook', this).on('click', function () {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + postUrl, "facebookWindow", "height=380,width=660,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0");
    });
  });

  $('body').on('show.bs.collapse', '.text-read-more .collapse[id*="ticket-description-"]', function() {
    $(this).prev('.text-preview').hide();
  });

  $('body').on('hide.bs.collapse', '.text-read-more .collapse[id*="ticket-description-"]', function() {
    $(this).prev('.text-preview').show();
  });

  var current_loc = null;
  var geo_callback = null;

  jQuery(function () {
    // Set current location & opco from cookie
    var tmp;
    if (tmp = document.cookie.match(/current_loc=([^;]+)/)) current_loc = tmp[1];
  });


// Geolocation items
//
// geo_loc_state has the following values:
//
//   not set: untried, so try now
//         0: declined by user, don't retry or re-alert
//         1: failed, retry but don't re-alert
//         2: succeeded, keep updating
//         3: overridden by manual input, don't retry automatic


  function geo_init(cb) {
    var tmp = document.cookie.match(/geo_loc_state=(\d)/);
    //console.log('initialising geolocation ' + tmp);
    if (cb) geo_callback = cb;

    if (!tmp || tmp[1] > 0) {
      if (navigator.geolocation) {
        navigator.geolocation.watchPosition(geo_process, geo_failed, { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 });
      } else {
        geo_failed({ code: 0, message: 'unsupported' });
      }
    } else {
      if (geo_callback) geo_callback(0);
    }
  }

  function geo_process(position) {
    var tmp = document.cookie.match(/geo_loc_state=(\d)/);
    //console.log('geolocation succeeds: ' + position.coords.latitude + ',' + position.coords.longitude);
    if (!tmp || tmp[1] == 1 || tmp[1] == 2) {
      document.cookie = 'geo_loc_state=2;path=/';
      document.cookie = 'geo_loc_warn=1;path=/';

      geo_set_loc(position.coords.latitude + ',' + position.coords.longitude);

      tmp = [0, 2];
    }

    if (geo_callback) geo_callback(tmp[1]);
  }

  function geo_failed(error) {
    document.cookie = 'geo_loc_state=' + (error.code < 2 ? 0 : 1) + ';path=/';

    var message = 'unknown';

    if (error) {
      message = error.message.toLowerCase();

      if (message == '') {
        switch (error.code) {
          case 1: message = 'denied by user'; break;
          case 2: message = 'unavailable'; break;
          case 3: message = 'timed out'; break;
          default: message = 'unknown'; break;
        }
      }
    }

    if (!document.cookie.match(/geo_loc_warn=1/)) {
      //console.log('Initial fail: ' + error.code + ' - ' + message);
      document.cookie = 'geo_loc_warn=1;path=/';

      if (!navigator.userAgent.match(/bot|googlebot|crawler|spider|robot|crawling/i))
        Drupal.dialog('<p class="m-0 fw-semibold text-center p-3">User location was not provided by your device (' + message + '): please enter or select location manually.</p>', {
          title: false,
          buttons: [{
            text: 'OK',
            click: function() {
              $(this).dialog('close');
            }
          }]
        }).showModal();
    } else {
      //console.log('Repeat fail: ' + error.code + ' - ' + message);
    }

    if (geo_callback) geo_callback(error.code < 2 ? 0 : 1);

    if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {
      geo_init();
    }
  }

  function geo_set_loc(loc) {
    current_loc = loc;

    document.cookie = 'current_loc=' + loc + ';path=/';

    if (typeof (gmapInit) != 'undefined' && typeof (ourGmap) != 'undefined') {
      if (ourGmap.action == gmapGetStops && typeof (ourGmap.myloc) == 'undefined') {
        gmapInit();
      } else {
        gmapUpdateLocation();
      }
    }
  }

  function geo_get_loc(loc) {
    jQuery.ajax({
      type: 'GET',
      url: '/geocoder?_format=json',
      data: 'location=' + urlencode(loc),
      success: function (data) {
        if (data.match(/-?[0-9]+(\.[0-9]+)?,-?[0-9]+(\.[0-9]+)?/)) {
          // Assume that if geolocation is in error state, manual input is a fix to this, not an override

          if (!document.cookie.match(/geo_loc_state=1/)) document.cookie = 'geo_loc_state=3;path=/';

          geo_set_loc(data);
        } else {
          Drupal.dialog('<p class="m-0 fw-semibold text-center p-3">' + data + '</p>', {
            title: false,
            buttons: [{
              text: 'OK',
              click: function() {
                $(this).dialog('close');
              }
            }]
          }).showModal();
        }
      }
    });
  }

  $('.user-location').on('click', function(e) {
    e.preventDefault();
    geo_init();
    // setControlBlock();

    if (current_loc) {
      jQuery.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/getOpco',
        data: 'coords=' + current_loc,
        success: function (data) {
          locationResult(data);
        },
        error: function() {
          Drupal.dialog('<p class="m-0 fw-semibold text-center p-3">There was a problem fetching locations.</p>', {
            title: false,
            buttons: [{
              text: 'OK',
              click: function() {
                $(this).dialog('close');
              }
            }]
          }).showModal();
        }
      });
    }
  });


  function doSetMyLocation(e) {
    e.preventDefault;

    var cid = jQuery(this).attr('data-ref');

    jQuery('#' + cid).val('My Location');
  }

  function locationResult(data) {
    if (data.error) {
      Drupal.dialog('<p class="m-0 fw-semibold text-center p-3">' + data.error + '</p>', {
        title: false,
        buttons: [{
          text: 'OK',
          click: function() {
            $(this).dialog('close');
          }
        }]
      }).showModal();
    } else {
      window.location.pathname = '/' + data.opco;
    }
  }

})(jQuery, Drupal, once);
